import React, { useRef, useState, useCallback, useMemo, useEffect } from 'react';
import { TransitionGroup, CSSTransition } from 'react-transition-group';
import { Translate } from '@pegasus/translation';
import { Text, Preset } from '@lux/text';
import { ControlsArrowsNext } from '@lux/icons';
import { FunctionColor } from '@lux/core';
import { track } from '../../../../lib/tracking';
import { StockStatus } from '../types';
import CartItem from './CartItem';
import RecoveredItem from './RecoveredItem';
import { Scroll } from './Scroll';
import { TRANSITION_TIMEOUT_MS } from './constants';
import { Wrapper, Scroller, ToggleUnavailable, ItemStockStatus } from './styles';
const noop = () => { };
export const CartItems = ({ items = [], recoveredItems = [], languageCode, onItemClick, onItemReserveAgain, onItemRemove, isPlusEnabled, cartInfoHeight, }) => {
    const scrollerRef = useRef(null);
    const [hover, setHover] = useState(false);
    const [unavailableHidden, setUnavailableHidden] = useState(true);
    const [peekUnavailable, setPeekUnavailable] = useState(true);
    const [isOverflown, setIsOverflown] = useState(false);
    const availableExpiredItems = useMemo(() => recoveredItems.filter(item => item.stockStatus === StockStatus.AVAILABLE), [recoveredItems]);
    const unavailableExpiredItems = useMemo(() => recoveredItems.filter(item => item.stockStatus !== StockStatus.AVAILABLE), [recoveredItems]);
    const allItems = useMemo(() => [...items, ...availableExpiredItems, ...unavailableExpiredItems], [items, availableExpiredItems, unavailableExpiredItems]);
    const visibleItemCounts = unavailableHidden
        ? items.length + availableExpiredItems.length
        : allItems.length;
    const onMouseEnter = useCallback(() => setHover(true), []);
    const onMouseExit = useCallback(() => setHover(false), []);
    const onToggleUnavailable = useCallback(() => {
        track(unavailableHidden ? 'cart_unavailableItems_show' : 'cart_unavailableItems_hide');
        setUnavailableHidden(!unavailableHidden);
    }, [unavailableHidden]);
    useEffect(() => {
        if (!unavailableHidden && peekUnavailable) {
            scrollerRef.current.scrollBy({ top: 100 });
            setPeekUnavailable(false);
        }
    }, [unavailableHidden, peekUnavailable]);
    useEffect(() => {
        if (scrollerRef.current) {
            setIsOverflown(scrollerRef.current.scrollHeight > scrollerRef.current.clientHeight);
        }
    }, [visibleItemCounts]);
    return (React.createElement(Wrapper, { isOverflown: isOverflown, onMouseEnter: onMouseEnter, onMouseLeave: onMouseExit, onScroll: noop },
        isOverflown && (React.createElement(Scroll, { itemCount: visibleItemCounts, parentRef: scrollerRef, visible: hover })),
        React.createElement(Scroller, { isOverflown: isOverflown, ref: scrollerRef, cartInfoHeight: cartInfoHeight },
            React.createElement(TransitionGroup, { exit: true, component: null }, items.map(item => {
                return (React.createElement(CSSTransition, { key: `${item.reservationId}`, timeout: TRANSITION_TIMEOUT_MS, classNames: "cart-item" },
                    React.createElement(CartItem, { ...item, languageCode: languageCode, onItemRemove: onItemRemove, onItemClick: onItemClick, isPlusEnabled: isPlusEnabled })));
            })),
            availableExpiredItems.length > 0 && (React.createElement(ItemStockStatus, null,
                React.createElement(Text, { preset: Preset.S },
                    React.createElement(Translate, { message: "expiredReservations" })))),
            React.createElement(TransitionGroup, { exit: true, component: null }, availableExpiredItems.map(item => (React.createElement(CSSTransition, { key: `${item.campaignIdentifier}_${item.simpleSku}`, timeout: TRANSITION_TIMEOUT_MS, classNames: "recovered-item" },
                React.createElement(RecoveredItem, { ...item, languageCode: languageCode, onItemReserveAgain: onItemReserveAgain }))))),
            unavailableExpiredItems.length > 0 && (React.createElement(ToggleUnavailable, { unavailableHidden: unavailableHidden, onClick: onToggleUnavailable },
                React.createElement(Text, { preset: Preset.S, color: FunctionColor.function0 },
                    React.createElement(Translate, { message: "unavailableArticles" })),
                React.createElement(ControlsArrowsNext, { color: FunctionColor.function0 }))),
            !unavailableHidden &&
                unavailableExpiredItems.map(item => (React.createElement(RecoveredItem, { ...item, languageCode: languageCode, onItemReserveAgain: onItemReserveAgain, key: `${item.campaignIdentifier}_${item.simpleSku}` }))))));
};
//# sourceMappingURL=index.js.map